/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * The game orientation enum
 * @export
 * @enum {string}
 */
export var FxIdDomainSettingsEGameOrientation;
(function (FxIdDomainSettingsEGameOrientation) {
    FxIdDomainSettingsEGameOrientation[FxIdDomainSettingsEGameOrientation["Horizontal"] = 0] = "Horizontal";
    FxIdDomainSettingsEGameOrientation[FxIdDomainSettingsEGameOrientation["Vertical"] = 1] = "Vertical";
    FxIdDomainSettingsEGameOrientation[FxIdDomainSettingsEGameOrientation["UnspecifiedOrientation"] = 2] = "UnspecifiedOrientation";
    FxIdDomainSettingsEGameOrientation[FxIdDomainSettingsEGameOrientation["NUMBER_unknown_default_open_api"] = 11184809] = "NUMBER_unknown_default_open_api";
})(FxIdDomainSettingsEGameOrientation || (FxIdDomainSettingsEGameOrientation = {}));
export function instanceOfFxIdDomainSettingsEGameOrientation(value) {
    for (const key in FxIdDomainSettingsEGameOrientation) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainSettingsEGameOrientation, key)) {
            if (FxIdDomainSettingsEGameOrientation[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FxIdDomainSettingsEGameOrientationFromJSON(json) {
    return FxIdDomainSettingsEGameOrientationFromJSONTyped(json, false);
}
export function FxIdDomainSettingsEGameOrientationFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FxIdDomainSettingsEGameOrientationToJSON(value) {
    return value;
}
export function FxIdDomainSettingsEGameOrientationToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FxIdDomainSettingsEGameOrientation.js.map